<template>
  <div>
    <el-descriptions :label-style="{width: '80px'}" :column="1" size="mini" border>
      <el-descriptions-item label="数据表">
        <el-select v-model="tableData.table" placeholder="请选择表">
          <el-option
            v-for="(item,index) in table_list"
            :key="index"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="表字段">
        <el-select v-model="tableData.field" placeholder="请选择字段">
          <el-option
            v-for="(item,index) in field_list"
            :key="index"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  name: "BpmnDatabase",
  props:{
    dataProps:{
      type:Object,
      default(){
        return {
          table:"",
          field:""
        };
      }
    }
  },
  model:{
    prop:"dataProps",
    event:"success",
  },
  data() {
    return {
      tableData:{
        table:"",
        field:""
      },
      table_list:[],
      field_list:[]
    }
  },
  mounted() {
    this.onInitTable()
  },
  watch: {
    dataProps:{
      deep:true,
      immediate:true,
      handler(n){
        this.onInitTable()
      }
    }
  },
  computed: {},
  methods: {
    onInitTable(){
      this.tableData=this.dataProps
    },
    changeInput(){
      this.$emit("success",this.tableData)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.form-input{
  width: 100%;
}
.footer{
  margin: 5px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/components/BpmnDatabase.vue